import "./expo.css";
import React, { createRef, useEffect, useRef, useState } from "react";
import add from "../../images/icons/add.png";
import close from "../../images/icons/close.png";
import CustomButton from "../../components/CustomButton/custombutton";
import edit from "../../images/icons/edit.png";
import view from "../../images/icons/view.png";
import CustomSearchBar from "../../components/CustomSearchBar/CustomSearchBar";
import apiUtil from "../../api/apiUtil";
import { Box } from "@material-ui/core";
import Table from "../../components/Table/Table";
import api from "../../api/api";
import getToken, { redirectToLogin } from "../getToken";
import authStore from "../../store/authStore";
import CustomInput from "../../components/CustomInput/CustomInput";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { format, parseISO } from 'date-fns';
import { message } from "antd";

const Expo = () => {
    const refExpoTable = useRef(null);
    const [selectedOption, setSelectedOption] = useState(null);
    const [isEdit, setIsEdit] = useState(false);
    const [isView, setIsView] = useState(false);
    const [keyword, setKeyword] = useState("");
    const expoId = useRef(0);

    const [showAddExpo, setShowAddExpo] = useState(false);
    const [detailExpo, setDetailExpo] = useState({
        expoName: "",
        date: "",
        address: "",
        description: "",
    });

    const brandId = authStore((state) => state.auth?.brandId);
    const clickAddExpo = () => {

        if (isEdit) {
            setIsEdit(false);
            setTimeout(() => setShowAddExpo(true), 100);
        } else {
            setShowAddExpo(true);
        }
        setIsView(false);
        setDetailExpo({});
    };

    const clickEditExpo = (e, id) => {

        setIsView(false);
        e.stopPropagation();
        clickBtnCloseForm();
        getExpoDetail(id);
    };

    const clickViewExpo = (rowData) => {

        setShowAddExpo(false);
        setIsEdit(false);
        setIsView(true);
        setDetailExpo({
            expoName: rowData.expoName,
            date: format(parseISO(rowData.date), 'yyyy-MM-dd'),
            address: rowData.address,
            description: rowData.description,
        })
        setTimeout(() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
        }, 0);
    };

    const clickBtnCloseForm = () => {
        setShowAddExpo(false);
        setIsEdit(false);
        setIsView(false);
    };


    const [expoList, setExpoList] = useState({
        isLoading: false,
        grouping: false,
        limit: apiUtil.getDefaultPageSize(),
        data: [],
        total: 0,
        page: 1,
    });

    const [paramExpo, setParamExpo] = useState({
        keyword: "",
        rowLimit: 10,
        currentPage: 1,
        sortBy: "",
        isDesc: true,
        brandId: brandId,
    });

    const retrieveExpoList = async (value = paramExpo) => {
        const request = {
            ...value,
            keyword: value.keyword || "",
            sortBy: selectedOption ? selectedOption.value : "",
        };

        try {
            setExpoList(prev => ({
                ...prev,
                isLoading: true,
            }));

            const result = await api.post(
                "Admin/GetExpoList",
                request,
                getToken()
            );

            apiUtil.parseResult(
                result,
                (response) => {
                    const { code, data } = response.data;
                    if (code === 401) {

                        message.error(response.data.message);

                        redirectToLogin();

                        return;
                    }
                    if (code === 200) {
                        setExpoList(prev => ({
                            ...prev,
                            isLoading: false,
                            limit: data.rowLimit,
                            data: data.data?.length ? data.data : [],
                            total: data.totalRecords,
                            page: data.paging,
                        }));
                        setTimeout(() => {
                            window.scrollTo({ top: 0, behavior: "smooth" });
                        }, 0);
                        return;
                    }

                    setExpoList(prev => ({
                        ...prev,
                        isLoading: false,
                        data: [],
                        total: 0,
                        page: 0,
                        limit: 0,
                    }));
                },
                (error) => {

                    console.error(error);
                    message.error("Failed to load expo list.");

                    setExpoList(prev => ({
                        ...prev,
                        isLoading: false,
                        data: [],
                        total: 0,
                        page: 0,
                        limit: 0
                    }));

                }
            );
        } catch (error) {

            console.error(error);
            message.error("Failed to load expo list.");

            setExpoList(prev => ({
                ...prev,
                isLoading: false
            }));
        }
    };

    const getExpoDetail = (id) => {
        api
            .get("Admin/GetExpoById", { expoId: id }, getToken())
            .then((result) => {
                apiUtil.parseResult(
                    result,
                    (response) => {
                        if (response.data.code === 401) {
                            message.error(response.data.message);
                            redirectToLogin();
                        } else if (response.data.code === 200) {
                            setDetailExpo({
                                expoName: response.data.data.expoName
                                    ? response.data.data.expoName
                                    : "",
                                date: response.data.data.date
                                    ? format(parseISO(response.data.data.date), "yyyy-MM-dd")
                                    : "",
                                address: response.data.data.address
                                    ? response.data.data.address
                                    : "",
                                description: response.data.data.description
                                    ? response.data.data.description
                                    : "",
                            });
                            expoId.current = id;
                            setIsEdit(true);
                            setTimeout(() => {
                                window.scrollTo({ top: 0, behavior: "smooth" });
                            }, 0);
                        } else {
                            message.warning(response.data.message);
                        }
                    },
                    (error, type) => {
                        console.log(error);
                    }
                );
            });
    };

    // Add Expo Validation Form
    const AddExpoValidation = Yup.object().shape({
        expoName: Yup.string().required("Please enter the expo name."),
        date: Yup.string().required("Please select the date."),
    });

    const submitExpoHandler = async (values, actions) => {
        const isUpdate = isEdit;

        const expo = {
            ...(isUpdate && {
                id: expoId.current
            }),
            brandId,
            expoName: values.expoName,
            date: format(
                parseISO(values.date),
                "yyyy-MM-dd"
            ),
            address: values.address,
            description: values.description,

        };

        const apiUrl = isUpdate
            ? "Admin/UpdateExpo"
            : "Admin/CreateExpo";

        try {
            const result = await api.post(
                apiUrl,
                expo,
                getToken()
            );

            apiUtil.parseResult(
                result,
                (response) => {

                    if (response.data.code === 401) {

                        message.error(response.data.message);

                        redirectToLogin();

                        return;
                    }

                    if (response.data.code === 200) {
                        message.success(
                            isUpdate
                                ? "Expo updated successfully!"
                                : "Expo saved successfully!"
                        );

                        actions.resetForm();

                        setIsEdit(false);
                        setShowAddExpo(false);
                        retrieveExpoList();

                        return;
                    }

                    message.warning(response.data.message);
                },
                () => {
                    message.error(
                        isUpdate
                            ? "An error occurred while updating expo."
                            : "An error occurred while saving expo."
                    );
                }
            );
        }
        catch (error) {
            console.error(error);
            message.error(
                isUpdate
                    ? "An error occurred while updating expo."
                    : "An error occurred while saving expo."
            );
        }
        finally {
            actions.setSubmitting(false);
        }
    };

    useEffect(() => {
        retrieveExpoList({
            ...paramExpo,
            keyword
        });
    }, [paramExpo.currentPage, selectedOption]);

    let pageTitle;
    if (showAddExpo) {
        pageTitle = "Add Expo";
    } else if (isEdit) {
        pageTitle = "Edit Expo";
    } else {
        pageTitle = "Expo Detail";
    }

    return (
        <>
            {(showAddExpo || isEdit || isView) && (
                <>
                    <div className="Actions space_between">
                        <h6 className="title_text mt-2">{pageTitle}</h6>
                        <button className="btn btnClose" onClick={clickBtnCloseForm}>
                            <img src={close} className="imgClose" alt="imgClose" />
                        </button>
                    </div>

                    {showAddExpo || isEdit ? (
                        <Formik
                            enableReinitialize={true}
                            initialValues={{
                                expoName: detailExpo.expoName,
                                date: detailExpo.date,
                                address: detailExpo.address,
                                description: detailExpo.description
                            }}
                            validationSchema={AddExpoValidation}
                            validateOnBlur={false}
                            onSubmit={submitExpoHandler}
                        >
                            {({ errors, touched, values, setFieldValue, isSubmitting }) => (
                                <Form className="row form-container add-expo-form">
                                    <div className="col-6 mt-2">
                                        <CustomInput
                                            name="expoName"
                                            type="text"
                                            label="Expo Name"
                                            placeholder="Expo Name"
                                            value={values.expoName}
                                            customclass="input_wrapper"
                                            hideicon="true"
                                        />
                                    </div>

                                    <div className="col-6 mt-2">
                                        <CustomInput
                                            name="date"
                                            type="date"
                                            label="Date"
                                            customclass="input_wrapper"
                                            hideicon="true"
                                        />
                                    </div>

                                    <div className="col-6 mt-2">
                                        <CustomInput
                                            name="address"
                                            type="text"
                                            label="Address"
                                            placeholder="Address"
                                            value={values.address}
                                            customclass="input_wrapper"
                                            hideicon="true"
                                        />
                                    </div>

                                    <div className="col-6 mt-2">
                                        <CustomInput
                                            name="description"
                                            type="text"
                                            label="Note"
                                            placeholder="Note"
                                            customclass="input_wrapper"
                                            hideicon="true"
                                        />
                                    </div>

                                    <div className="col-12 mt-3">
                                        <div className="Actions justify-content-end">
                                            <button
                                                type="button"
                                                className="button btnCancel"
                                                onClick={clickBtnCloseForm}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                type="submit"
                                                className="button btnAddPM"
                                                disabled={isSubmitting}
                                            >
                                                {
                                                    isSubmitting
                                                        ? "Saving..."
                                                        : showAddExpo
                                                            ? "Create"
                                                            : "Update"
                                                }
                                            </button>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    ) : null}

                    {isView && (
                        <>
                            <Formik
                                initialValues={detailExpo}
                                validateOnBlur={false}
                            >
                                {({ errors, touched, setFieldValue }) => (
                                    <Form className="row form-container add-expo-form">
                                        <div className="col-6 mt-2">
                                            <CustomInput
                                                name="expoName"
                                                type="text"
                                                label="Expo Name"
                                                placeholder="Expo Name"
                                                customclass="input_wrapper"
                                                hideicon="true"
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-6 mt-2">
                                            <CustomInput
                                                name="date"
                                                type="date"
                                                label="Date"
                                                customclass="input_wrapper"
                                                hideicon="true"
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-6 mt-2">
                                            <CustomInput
                                                name="address"
                                                type="text"
                                                label="Address"
                                                placeholder="Address"
                                                customclass="input_wrapper"
                                                hideicon="true"
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-6 mt-2">
                                            <CustomInput
                                                name="description"
                                                type="text"
                                                label="Note"
                                                placeholder="Note"
                                                customclass="input_wrapper"
                                                hideicon="true"
                                                readOnly
                                            />
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </>
                    )}
                </>
            )
            }

            <div className="Actions space_between">
                <h6 className="title_text mt-2">Expo</h6>
                <div className="d-flex justify-content-end gap-16 align-items-center"s>
                    <CustomSearchBar
                        value={keyword}
                        setValue={setKeyword}
                        onSearch={(value) => retrieveExpoList({
                            ...paramExpo,
                            keyword: value || "",
                            currentPage: 1
                        })}
                    />
                    {!showAddExpo && (
                        <CustomButton
                            icon={add}
                            text="Add Expo"
                            addIcon={true}
                            className="btnAdd"
                            onClick={clickAddExpo}
                        />
                    )}
                </div>
            </div>

            <div className="table_container expo_table">
                <Table
                    ref={refExpoTable}
                    maxBodyHeight={expoList.limit * 100}
                    isLoading={expoList.isLoading}
                    grouping={expoList.grouping}
                    limit={expoList.limit}
                    page={expoList.page}
                    total={expoList.total}
                    data={expoList.data}
                    onPageChange={(page) => {
                        setParamExpo({
                            ...paramExpo,
                            currentPage: page,
                        });
                        retrieveExpoList(paramExpo);
                    }}
                    columns={[
                        {
                            title: "No",
                            render: (row) => row.tableIndex + 1
                        },
                        {
                            title: "Expo Name",
                            field: "expoName"
                        },
                        {
                            title: "Date",
                            render: (row) => {
                                return row.date ? format(parseISO(row.date), 'dd MMM yyyy') : "-"
                            },
                        },
                        {
                            title: "Address",
                            field: "address",
                        },
                        {
                            title: "Note",
                            field: "note"
                        },
                        {
                            title: "Edit",
                            sorting: false,
                            render: (row) => {
                                return (
                                    <Box
                                        className="editIcon"
                                        onClick={(e) => clickEditExpo(e, row.id)}
                                    >
                                        <img src={edit} alt="" className="imgIcon" />
                                    </Box>
                                );
                            },
                            width: "80px",
                            align: "center",
                        },
                        {
                            title: "View",
                            sorting: false,
                            render: (row) => {
                                return (
                                    <Box
                                        className="viewIcon"
                                        onClick={() => clickViewExpo(row)}
                                    >
                                        <img src={view} alt="" className="imgIcon" />
                                    </Box>
                                );
                            },
                            width: "80px",
                            align: "center",
                        },
                    ]}
                />
            </div>
        </>
    )
}
export default Expo;